const imageBaseUrl =
  'https://assets.salieflewis.com/261014_ncpp_dot_com_finals/web';

// Web versions of the NCPP finals, paired by location and subject.
// The source photographs remain in the parent R2 folder.
const photographs = [
  {
    file: 'untitled_alsdorf_farm_1_symone_small',
    alt: 'Black-and-white photograph of dense trees and undergrowth at Alsdorf Farm',
    width: 1280,
    height: 864,
  },
  {
    file: 'untitled_alsdorf_farm_2_rough_retouch',
    alt: 'Black-and-white photograph of a large boulder beneath an overcast sky at Alsdorf Farm',
    width: 1600,
    height: 1083,
  },
  {
    file: 'untitled_roe_barn',
    alt: 'Black-and-white photograph of a weathered wooden barn beside an open field at Roe Barn',
    width: 1600,
    height: 1073,
  },
  {
    file: 'untitled_strawridge_1',
    alt: 'Black-and-white photograph of a collapsing wooden structure at Strawridge',
    width: 1600,
    height: 1080,
  },
  {
    file: 'untitled_quassaick_1_symone_small',
    alt: 'Black-and-white photograph of slender tree trunks and tangled woodland at Quassaick',
    width: 1600,
    height: 1143,
  },
  {
    file: 'untitled_wappinger_creek_2',
    alt: 'Black-and-white photograph looking up through treetops toward a cloudy sky at Wappinger Creek',
    width: 1600,
    height: 1078,
  },
];

export function TruthBeTold() {
  return (
    <section
      aria-label="Truth Be Told"
      className="mx-auto grid w-full max-w-[1280px] grid-cols-1 items-center gap-y-10 px-4 pb-28 pt-4 sm:px-8 md:grid-cols-2 md:gap-x-12 md:gap-y-24 md:pb-36 md:pt-8 lg:gap-x-20 lg:px-12"
    >
      <section
        aria-label="About the series"
        className="mx-auto w-full max-w-[860px] space-y-5 border border-black/20 p-5 text-base font-light leading-relaxed sm:p-8 md:col-span-2 md:p-10 md:text-lg"
      >
        <p>
          The photographs that make up this series are representations of
          respective stories and histories surrounding the Underground Railroad.
          The tales that serve as the basis for this work are fragmented in
          nature, full of unknowns and suppositions.
        </p>
        <p>
          In beginning to create these images, I was eager to uncover hidden
          details pertaining to various locations and individuals. I was
          entrenched in the idea that this type of evidence would allow me to
          tell better stories.
        </p>
        <p>
          As I continued to research and travel to different locations, I began
          to realize that it was the absence of these details that became
          important to me.
        </p>
        <p>
          I shifted focus to creating space for these unknowns, building upon
          imagined perspectives and leaving room for these environments to echo
          their own histories.
        </p>
      </section>
      {photographs.map((photograph, index) => (
        <img
          key={photograph.file}
          src={`${imageBaseUrl}/${photograph.file}-${photograph.width}.webp`}
          srcSet={`${imageBaseUrl}/${photograph.file}-800.webp 800w, ${imageBaseUrl}/${photograph.file}-${photograph.width}.webp ${photograph.width}w`}
          sizes="(min-width: 1280px) 552px, (min-width: 1024px) calc((100vw - 176px) / 2), (min-width: 768px) calc((100vw - 112px) / 2), (min-width: 640px) calc(100vw - 64px), calc(100vw - 32px)"
          alt={photograph.alt}
          width={photograph.width}
          height={photograph.height}
          loading={index < 2 ? 'eager' : 'lazy'}
          fetchPriority={index === 0 ? 'high' : 'auto'}
          decoding="async"
          className="block aspect-[3/2] w-full object-cover"
        />
      ))}
    </section>
  );
}
